import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IWikifolioAlphaKeyFigureGroupSection } from "src/api/server/wf-detail.types";
import { IconWikifolio } from "src/components/icons";
import { AlphaWithPerformanceValue } from "src/components/pages/detail/key-figures/components/alpha/alpha-with-performance-value";
import { useDateTimeFormatter } from "src/hooks/formatters/use-date-time-formatter";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";

interface IBestAlphaProps {
    shortDescription: string;
    creationDate: string;
    alpha: IWikifolioAlphaKeyFigureGroupSection["bestAlpha"];
}

export const BestAlpha = ({ shortDescription, creationDate, alpha }: IBestAlphaProps) => {
    const { t } = useTranslation("wf-detail");
    const { formatPercent, formatNumber } = useNumberFormatter();
    const { formatDateShort } = useDateTimeFormatter();

    const text = alpha.useCreationDate
        ? t("alpha.best-alpha-since", {
              0: shortDescription,
              1: alpha.benchmarkName,
              2: formatDateShort(creationDate),
              3: formatPercent(alpha.confidenceCategory, 0),
              4: formatNumber(alpha.alphaStatistic, 2),
          })
        : t("alpha.best-alpha-years", {
              0: shortDescription,
              1: alpha.benchmarkName,
              2: alpha.timespanYears,
              3: formatPercent(alpha.confidenceCategory, 0),
              4: formatNumber(alpha.alphaStatistic, 2),
          });

    return (
        <Typography>
            <IconWikifolio mr={0.5} verticalAlign="bottom" mb="3px" />
            <AlphaWithPerformanceValue value={alpha.alphaEstimateAnnualized} text={text} />
        </Typography>
    );
};
